import { useParams } from 'react-router-dom';
import { MilestonePage } from './MilestonePage';

export const Milestones: React.FC = () => {
	const { guid } = useParams<'guid'>();

	return <MilestonePage dataRoomGuid={guid} />;
};
